import { SHeaderContainer, SHeaderNav, SHeaderWrapper } from './DigitalLegacyHeader.styled'
import { HeaderNavItem } from 'components/header/Header'
import { HeaderTopNavigation } from 'components/header/headerTopNavigation/HeaderTopNavigation'
import { useMobileNavigationModal } from 'components/navigation/MobileNavigationModal'

import LogoDigitalLegacy from 'images/extra-svg/LogoDigitalLegacy.svg'
import Link from 'next/link'
import { DigitalLegacyHeaderButton } from 'pages/book'

export function DigitalLegacyHeader(props: {
  onItemClick?: (type: DigitalLegacyHeaderButton) => void
}) {
  const navContent = (
    <SHeaderNav open>
      <HeaderNavItem
        onClick={async () => {
          await closeMobileModal()
          props.onItemClick?.('buy')
        }}
      >
        Buy
      </HeaderNavItem>
      <HeaderNavItem
        onClick={async () => {
          await closeMobileModal()
          props.onItemClick?.('about')
        }}
      >
        About
      </HeaderNavItem>
      <HeaderNavItem
        onClick={async () => {
          await closeMobileModal()
          props.onItemClick?.('author')
        }}
      >
        Authors
      </HeaderNavItem>
      <HeaderNavItem
        onClick={async () => {
          await closeMobileModal()
          props.onItemClick?.('review')
        }}
      >
        Reviews
      </HeaderNavItem>
    </SHeaderNav>
  )

  const [mobileModal, isMobileModalOpen, openMobileModal, closeMobileModal] =
    useMobileNavigationModal({
      customContent: navContent,
    })

  return (
    <SHeaderWrapper open={isMobileModalOpen}>
      {mobileModal}
      <SHeaderContainer>
        <HeaderTopNavigation
          isOpen={isMobileModalOpen}
          toggleOpen={isMobileModalOpen ? closeMobileModal : openMobileModal}
          logo={
            <Link href="/" legacyBehavior>
              <LogoDigitalLegacy />
            </Link>
          }
          showMenu
        />

        {!isMobileModalOpen && <SHeaderNav>{navContent}</SHeaderNav>}
      </SHeaderContainer>
    </SHeaderWrapper>
  )
}
